import type { Address } from '~/common/components/addresses'
import type { ServicePointVendorAddressDto } from '~/modules/servicepointvendors/model'

export const convertToServicepointVendorAddress = ({
  houseNumber,
  postalCode,
  houseNumberAddition,
  country,
  ...address
}: ServicePointVendorAddressDto): Address => ({
  ...address,
  isBusiness: true,
  houseNumber,
  houseNumberSuffix: houseNumberAddition || '',
  postalCode,
  countryCode: country,
})
